export default "__VITE_ASSET__BRzcXAiC__"